
const ROOT_URL = ""

if (!localStorage.getItem("randomNumber")) {
  //generate 5 digit random no
  const min = 10000;
  const max = 99999;
  const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
  console.log("----- random number ----->", randomNumber);
  localStorage.setItem("randomNumber", randomNumber);
}
//----> session id generate logic
var sessionTime = localStorage.getItem("sessionTime")
  ? localStorage.getItem("sessionTime")
  : "";
var sessionId = sessionStorage.getItem("sessionId")
  ? sessionStorage.getItem("sessionId")
  : "";
if (sessionTime && sessionId && Date.now() - sessionTime > 300000) {
  // 5 min
  console.log(
    "----- session id updated : --->" +
    Date.now() +
    "" +
    localStorage.getItem("randomNumber")
  );
  const a = Date.now() + "" + localStorage.getItem("randomNumber");
  sessionStorage.setItem("sessionId", a);
  localStorage.setItem("user_type", "repeatedUser"); // repeated user
}
sessionTime = Date.now();
if (sessionId === "") {
  //set session id for first time only
  sessionId = sessionTime + "" + localStorage.getItem("randomNumber");
  sessionStorage.setItem("sessionId", sessionId);
}

const getHeaders = () => {
  const defaultHeaders = {
    'Content-Type': "application/json",
    "accept": 'application/json',
    "campid": sessionStorage.getItem("camp") || "NA",
    "rcid": sessionStorage.getItem("rcid") || "NA",
    "w_req_url": window.location.href,
    "msisdn": localStorage.getItem("msisdn") || "NA",
    "sid": sessionStorage.getItem("sessionId") || "NA",
  };

  return defaultHeaders;
}

export async function GET(path, data, options = {}) {

  const headers = {
    ...getHeaders()
  };

  const response = await fetch(path, {
    method: "GET",
    ...(data) && { params: data },
    headers
  });

  const res = await response.json()
  return res
}

export async function POST(path, data, options = {}) {
window.localStorage.setItem("lang","ar")
  const headers = {
    defaultlanguage:"ar",
    operatorid: "zainlibyanaop",
    timezone: "+1",
    ...getHeaders()
  };
 
  const response = await fetch(path, {
    method: "POST",
    ...options,
    body: JSON.stringify(data),
    headers,
  })
  return response.json();
}